import { DCol } from "./DCol";
import { DText } from "./DText";

export function DTextTutorial({ title, data }: { title?: string, data: string[] }) {
    return <DCol style={{ background: 'linear-gradient(45deg, #FFD700, #FF8C00)', borderRadius: 5, padding: 10, margin: 10, marginBottom: 20 }}>
        <DText style={{ marginBottom: 20, fontSize: 20 }}> {title || '💡 Tips and Keyboard shortcuts 💡'}</DText>
        {data.map((d, dx) => <DText key={dx}>✅ {d}</DText>)}
    </DCol>
}